import Image from 'next/image';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import StyledLink from '../../../../shared/components/global/StyledLink';
import { Company } from '../../../../shared/model/Company';
import { Job } from '../../../../shared/model/Job';
import { Container, ContainerContentStandard } from '../../../../shared/styles/container';
import { device } from '../../../../shared/styles/device';
import { BUCKET_URL } from '../../model/S3Bucket';

const TopCompaniesSectionContainer = styled.section`
  padding-top: 64px;
  padding-bottom: 64px;
  background: white;
  margin: 128px 0;
  border-radius: 30px;

  h2 {
    margin-bottom: 8px;
  }
  h3 {
    margin-bottom: 48px;
    font-size: 18px;
    font-weight: 500;
    line-height: 32px;
    margin: 0px;
  }
`;
const TopCompaniesGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);

  @media ${device.tablet} {
    grid-template-columns: minmax(0, 2fr) minmax(0, 3fr);
    grid-column-gap: 48px;
  }
`;
const MediaImageRow = styled.div`
  width: 100%;
  overflow: visible;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-column-gap: 24px;
  grid-row-gap: 24px;
  align-items: center;
  justify-content: center;
  padding: 32px 0;

  .gatsby-image-wrapper {
    margin: auto;
  }


  @media ${device.tablet} {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    padding: 0;
  }
`;
const MediaImageItem = styled.div`
    width: 100%;
    height: 100%;    
    overflow: visible;
    position: relative;
    min-height: 80px;
    transition: all 300ms ease;

    &:hover {
      transform: scale(1.1);
    }
`
const MediaTextColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 32px;

  @media ${device.tablet} {
    margin-bottom: 0;
  }

  h2 {
    margin-top: 0;
    margin-bottom: 8px;
  }
`;

interface Props {
  jobs: Job[];
}

export const TopCompanies = ({ jobs }: Props) => {

  const [topCompanies, setTopCompanies] = useState<Company[]>([]);

  const getTopCompaniesFromJobs = () => {
    if (jobs?.length > 0) {
      const companies: Company[] = [];
      jobs.forEach((job) => {
        if (job.company != null && job.company?.logoUrl != null && job.company?.logoUrl != "") {
          if (!companies?.find((company) => company.slug === job?.company?.slug)) {
            companies.push(job.company)
          }
        }
      });

      try {
        companies?.sort((a, b) => parseInt(a.numberOfEmployees) > parseInt(b.numberOfEmployees) ? -1 : 1);
        const numberOfCompanies = companies?.length;
        setTopCompanies(companies?.slice(0, numberOfCompanies >= 6 ? 6 : numberOfCompanies));

      } catch (error) {
        // parseInt is tricky, normally should be a number
        console.error(error);
      }
    }
  }

  useEffect(() => {
    getTopCompaniesFromJobs();
  }, [])


  return (
    <TopCompaniesSectionContainer>
      <Container>
        <ContainerContentStandard>
          <TopCompaniesGrid>
            <MediaTextColumn>
              <h2>Top-Unternehmen, <br /> die einstellen</h2>
              <h3>Diese Unternehmen haben Jobs in der STELL-MICH-EIN Jobbörse ausgeschrieben.</h3>
            </MediaTextColumn>
            <MediaImageRow>
              {topCompanies?.length > 0 && topCompanies.map((topCompany, index) =>
                <StyledLink key={"topcompany-logo-" + index} href={`/companies/${topCompany?.slug}`}>
                  <MediaImageItem>
                    <Image priority loading='eager' quality={100} src={BUCKET_URL + topCompany?.logoUrl} alt="Company Logo" height={120} width={120} />
                  </MediaImageItem>
                </StyledLink>
              )}
            </MediaImageRow>
          </TopCompaniesGrid>
        </ContainerContentStandard>
      </Container>
    </TopCompaniesSectionContainer >
  )
}
